import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseApiService } from '../base-api.service';
import { UserService } from '../user/user.service';
import { StringParameterModel } from '../../models/StringParameterModel';
import { SearchResults } from '../../models/SearchResults';
import { ICccSearchParameters } from '../../models/CccSearchParameters';

@Injectable({
  providedIn: 'root',
})
export class CccReportService {
  token = '';
  baseUrl = window.location.origin;

  constructor(
    private baseAPIServices: BaseApiService,
    public user: UserService,
  ) {
    this.user.token.subscribe(value => {
      this.token = value;
    });
  }

  public GetCCCReport(request: ICccSearchParameters): Promise<SearchResults> {
    let url = this.baseUrl + '/api/cccReport/GetCCCReport';
    this.baseAPIServices.headerToken = this.token;
    //var result = this.baseAPIServices.getTU<SearchResults>(url, request);
    var result = this.baseAPIServices.postTU<
      ICccSearchParameters,
      SearchResults
    >(url, request);
    return result;
  }
}

export interface UnspscData {
  code: string;
  description: string;
  eventCount: number;
}
export interface PSCData {
  description: string;
}
export interface Vendor {
  name: string;
}
